export default function initTestimonialsTabs(): void {
    const $testimonialsTabsContainer = document.querySelectorAll<HTMLElement>('.block-testimonials-tabs');
    $testimonialsTabsContainer.forEach($container => {
        new TestimonialsTabs($container);
    });
}

class TestimonialsTabs {
    $el: HTMLElement | null | undefined;
    $tabs: NodeListOf<HTMLElement> | null | undefined;
    $panels: NodeListOf<HTMLElement> | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        
        if (this.$el) {
            this.$tabs = this.$el.querySelectorAll<HTMLElement>('[role="tab"]');
            this.$panels = this.$el.querySelectorAll<HTMLElement>('[role="tabpanel"]');
            
            this.init();
        }
    }

    init(): void {
        if (!this.$tabs || !this.$panels || this.$tabs.length === 0) {
            return;
        }
        
        // Ajouter les écouteurs d'événements sur les onglets
        this.$tabs.forEach(tab => {
            // Gestion du clic
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                this.activateTab(tab);
            });
            
            // Gestion du clavier
            tab.addEventListener('keydown', (e) => {
                this.handleKeydown(e, tab);
            });
        });
        
        // Activer le premier onglet par défaut si aucun n'est déjà actif
        if (this.$el) {
            const activeTab = this.$el.querySelector<HTMLElement>('[role="tab"][aria-selected="true"]');
            if (!activeTab && this.$tabs.length > 0) {
                this.activateTab(this.$tabs[0]);
            }
        }
    }
    
    /**
     * Active l'onglet sélectionné et affiche le panneau correspondant
     */
    activateTab(tab: HTMLElement): void {
        if (!this.$tabs || !this.$panels) {
            return;
        }
        
        // Désactiver tous les onglets et panneaux
        this.$tabs.forEach(t => {
            t.setAttribute('aria-selected', 'false');
            t.classList.remove('active');
        });
        
        this.$panels.forEach(p => {
            p.setAttribute('aria-hidden', 'true');
            p.classList.remove('active');
        });
        
        // Activer l'onglet sélectionné
        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('active');
        
        // Activer le panneau correspondant
        const panelId = tab.getAttribute('aria-controls');
        if (panelId) {
            const targetPanel = document.getElementById(panelId);
            if (targetPanel) {
                targetPanel.setAttribute('aria-hidden', 'false');
                targetPanel.classList.add('active');
            }
        }
    }
    
    /**
     * Gère la navigation au clavier entre les onglets
     */
    handleKeydown(e: KeyboardEvent, currentTab: HTMLElement): void {
        if (!this.$tabs) {
            return;
        }
        
        const tabsArray = Array.from(this.$tabs);
        const currentIndex = tabsArray.indexOf(currentTab);
        let newTab: HTMLElement | null = null;
        
        switch (e.key) {
            case 'ArrowRight':
            case 'ArrowDown':
                e.preventDefault();
                // Passer à l'onglet suivant ou revenir au premier
                newTab = tabsArray[(currentIndex + 1) % tabsArray.length];
                break;
                
            case 'ArrowLeft':
            case 'ArrowUp':
                e.preventDefault();
                // Passer à l'onglet précédent ou aller au dernier
                newTab = tabsArray[(currentIndex - 1 + tabsArray.length) % tabsArray.length];
                break;
                
            case 'Home':
                e.preventDefault();
                // Aller au premier onglet
                newTab = tabsArray[0];
                break;
                
            case 'End':
                e.preventDefault();
                // Aller au dernier onglet
                newTab = tabsArray[tabsArray.length - 1];
                break;
                
            case 'Enter':
            case ' ': // Espace
                e.preventDefault();
                // Activer l'onglet courant
                this.activateTab(currentTab);
                break;
        }
        
        // Si un nouvel onglet est sélectionné, le mettre en focus et l'activer
        if (newTab) {
            newTab.focus();
            this.activateTab(newTab);
        }
    }
}
